import config from './config'

/* Milliseconds in a day */
const MS_IN_DAY = 1000 * 60 * 60 * 24

/**
 * Zero-pads the number to a given length
 * @param {Number} number 
 * @param {Number} length 
 * @returns {String}
 */
function zeroPad(number, length) {
  return number.toString().padStart(length, '0')
}

/**
 * Fully formats the date in specified format
 * @param {Date} date The date to format
 * @param {String} format The string consisting of 
 */
export function formatDate(date, format) {
  const dayFormat = format.match(/d+/i)
  const monthFormat = format.match(/m+/i)
  const yearFormat = format.match(/y+/i)

  /* Formatted components */
  let day, month, year

  /* Logic for formatting day */
  if (dayFormat && dayFormat.length) {
    day = zeroPad(date.getDate(), dayFormat[0].length)
  }

  /* Logic for formatting month */
  if (monthFormat && monthFormat.length) {
    month = zeroPad(date.getMonth() + 1, monthFormat[0].length)
  }

  /* Logic for formatting year. Strip or zero-pad if required */
  if (yearFormat && yearFormat.length) {
    year = zeroPad(
      date.getFullYear() % Math.pow(10, yearFormat[0].length),
      yearFormat[0].length
    )
  }

  /* Format accordingly */
  return format
    .replace(dayFormat && dayFormat[0], day)
    .replace(monthFormat && monthFormat[0], month)
    .replace(yearFormat && yearFormat[0], year)
}

/**
 * Date formatting to the server string
 * @param {Date|String} date The date to format
 * @returns {String} The date formatted in configured format
 * @see config.dateFormat
 */
export function formatDateToServerString(date) {
  return formatDate(date, config.dateFormat)
}

/**
 * Gets the next (in the future) day to the provided
 * @param {Date} date
 * @returns {Date}
 */
export function nextDayFrom(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1)
}

/**
 * Calculates the day difference between two dates
 * @param {Date|Number} date1 The first date
 * @param {Date|Number} date2 The second date
 * @returns {Number} The number of days between two days
 */
export function dayDiff(date1, date2) {
  return Math.round(Math.abs(date2 - date1) / MS_IN_DAY)
}